import { render, staticRenderFns } from "./module-permission.vue?vue&type=template&id=503ce6c7&scoped=true"
import script from "./module-permission.vue?vue&type=script&lang=ts"
export * from "./module-permission.vue?vue&type=script&lang=ts"
import style0 from "./module-permission.vue?vue&type=style&index=0&id=503ce6c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503ce6c7",
  null
  
)

export default component.exports